import { Text } from "components/shared/text";
import { FC } from "react";
import useTranslation from "utils/hooks/useTranslation";

export const EmptyContent: FC<{ text: string }> = ({ text }) => {
  const { t } = useTranslation();
  return (
    <group
      data-space="20"
      data-align="center"
      data-justify="center"
      data-direction="column"
    >
      <space></space>

      <icon data-opacity="20" data-icon-size="large">
        empty_dashboard
      </icon>

      <Text
        data-text-align="center"
        data-light=""
        data-wrap="wrap"
        data-line="1.5"
        data-max-length="300"
      >
        <div dangerouslySetInnerHTML={{ __html: t(text) }} />
      </Text>
      <space></space>
    </group>
  );
};
